module.exports = __webpack_public_path__ + "img/all-dark.887d7e7.png";